import type { ReactNode } from 'react';
import React from 'react';

export interface TabViewProps {
  children: React.ReactNode;
  activeTab: string;
}

interface TabProps {
  name: string;
  children: ReactNode;
}

const Tab = ({ children, name }: TabProps) => <div data-testid={'tab-' + name}>{children}</div>;

const TabView = ({ children, activeTab }: TabViewProps) => (
  <>
    {React.Children.map(children, (child) => {
      if (React.isValidElement(child) && child.type === Tab && child.props.name === activeTab) {
        return child.props.children;
      }
      return null;
    })}
  </>
);

TabView.Tab = Tab;
export default TabView;
